module.exports = __webpack_public_path__ + "img/second.0e51674b.jpg";